export const discordJumpLinkMap = {
    'en': 'https://discord.gg/ePxJKBQnF5',
    'de': 'https://discord.gg/zXcRR97',
    'fr': 'https://discord.gg/t763YBK',
    'it': 'https://discord.gg/ePxJKBQnF5'
}